import { createAiPromptRequest } from '../../../../ai-insights/aiInsightsTypes';
import { transactionActionExecutionProfiles } from '../../executionProfiles';
import type { TransactionActionRunnerOutput } from '../../proposalTypes';
import type { TransactionActionRunner } from '../../runners';
import { renamePayeePrompt } from './prompt';

const RENAME_PAYEE_AGENT_ID = 'ai-insights-v2';

export const renamePayeeStructuredModelRunner: TransactionActionRunner = {
  id: 'structured_model',
  buildOutput({ batch }): TransactionActionRunnerOutput {
    if (batch.capability !== 'rename_payee' || batch.eligibleTransactions.length === 0) {
      return null;
    }

    const profile = transactionActionExecutionProfiles.rename_payee;

    return {
      transport: 'structured_model',
      request: createAiPromptRequest({
        userPrompt: { text: renamePayeePrompt.prompt },
        agent: RENAME_PAYEE_AGENT_ID,
        context: {
          text: renamePayeePrompt.contextPrefix,
          data: { transactions: batch.eligibleTransactions },
        },
        outputSchema: renamePayeePrompt.schema.schema,
        options: {
          model: profile.model,
          temperature: profile.temperature,
          maxOutputTokens: profile.maxOutputTokens,
        },
      }),
    };
  },
};
